<template>
  <b-form-group :class="[
    `${name}-group custom-input-select`,
    {'mandatory': mandatory},
     vflowGetFeedbackClasses('selected_')
  ]">
    <label :for="name" class="d-inline-block" :class="{'mandatory': mandatory}"><slot name="lbl">{{name}} (Default-Text)</slot></label>
    <slot :name="`txtAfterLabel`"></slot>
    <BrandedDropdown
      :name="name"
      :autocomplete="autocomplete"
      :options="options"
      :clearable="!mandatory && clearable"
      :disabled="disabled"
      :placeholder="placeholder"
      :selected.sync="selected_"
      :tracking="tracking"
      @keyup.enter.prevent="vflowInputFocused('selected_')"
      @keyup.tab="vflowInputFocused('selected_')"
      @focus="vflowInputFocused('selected_')"
      @click="vflowInputFocused('selected_')"
      @input="vflowInputFocused('selected_')"
      @blur="vflowInputBlurred('selected_')"
    >
      <template v-for="slot in possibleChildSlotsFor('Dropdown')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </BrandedDropdown>
    <b-form-invalid-feedback>
      <slot name="txtRequiredLength" v-if="$v.selected_.required === false">
        Dies ist ein Pflichtfeld.
      </slot>
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import syncProperty from '@/mixins/syncProperty'
import BrandedDropdown from '@/components/forms/BrandedDropdown.vue'
import validationFlow from '@/mixins/validators/validationFlow'
import { validationMixin } from 'vuelidate'
import required from 'vuelidate/lib/validators/required'

export default {
  name: 'LabeledBrandedDropdown',
  components: { BrandedDropdown },
  mixins: [
    validationMixin,
    validationFlow,
    syncProperty('selected', 'selected_')
  ],
  watch: {
    '$v.$invalid': {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: 'Bitte wählen'
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mandatory: {
      type: Boolean,
      default: false
    },
    tracking: {
      type: Function,
      default: null
    }
  },
  validations () {
    return {
      selected_: {
        ...(this.mandatory ? { required } : {})
      }
    }
  }
}
</script>
